import { ChangeDetectionStrategy, Component, computed, inject, signal} from '@angular/core';
import { ContractingService } from 'src/app/shared/services/contracting.service';

import { MessageService } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { CardModule } from 'primeng/card';
import { StepperModule } from 'primeng/stepper';
import { CommonModule } from '@angular/common';
import { SignatureComponent } from 'src/app/shared/modules/signature/signature/signature.component';
import { Checkbox } from 'primeng/checkbox';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@Component({
    imports: [
        ButtonModule,
        CardModule,
        StepperModule,
        CommonModule,
        SignatureComponent,
        Checkbox,
        ReactiveFormsModule,
        FormsModule
    ],
    selector: 'app-new-contract',
    templateUrl: './newContract.component.html',
    providers: [MessageService],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class NewContractComponent{
  private contractService = inject( ContractingService );
  private ms = inject( MessageService );

  public op = computed(() => this.contractService.currentOperation() );

  public signature = signal<string | undefined>(undefined);

  public  acceptedTos:boolean = false;
  public isProcessing:boolean = false;

  resetSignature():void {
    this.signature.set( undefined ) ;
  }

  onSignatureCompleted(event:string) {
    this.signature.set(event)
  }

  async handleCompleteOperation() {
    this.isProcessing = true;
    const newOp = Object.assign(this.op()!, {
      status: this.op()!.desglose ? 3 : 2,
      contract: {
        'signature': this.signature(),
        'signatureDate': Date.now()
      }
    })
    const resp = await this.contractService.signOperationFromClient(newOp);
    if (!resp) {
      this.ms.add({severity: 'error', summary: 'Se ha producido un error generando tu contrato, por favor inténtalo de nuevo'});
      this.isProcessing = false;
      return;
    } else {
      this.contractService.endSign();
      this.isProcessing = false;
      console.log(this.contractService.currentContract());
      console.log(this.contractService.currentOperation());
    }

  }
  

}
